import { Component } from '@angular/core';


@Component({
  selector: 'app-company-sites',
  templateUrl: './company-sites.component.html',
  styleUrls: ['./company-sites.component.css']
})
export class CompanySitesComponent {
  
  sites = [];
  dataLoaded : boolean = false;
  value = false;
  constructor() {  
  }
  toggle($event){
   this.value =  !this.value;
  }

}
